import { createStore } from 'shared/stores/create-store';

type TState = {
  search: string;
};

type TActions = {
  setSearch: (value: string) => void;
};

export const useClientOrdersSearchStore = createStore<TState & TActions>(
  (set) => ({
    search: '',
    setSearch: (search: string) => set((state) => ({ ...state, search })),
  }),
  'client-orders-search-store',
);
